import { 
    setGlobalData,
    setCustomerData,
    setDistributorData,
    setPrevGlobalData
} from './actions';

 
const dispatchCurrentGlobalData = (dispatch:any) => (loaclparma:any) =>{
    dispatch(setGlobalData(loaclparma));
}

const dispatchCustomerData = (dispatch: any) => (values: any) => {
    dispatch(setCustomerData(values));
}

const dispatchDistributorData = (dispatch: any) => (values: any) => {
    dispatch(setDistributorData(values))
}

const dispatchCurrentPrevGlobalData = (dispatch: any) => (loaclparma: any) => {
    dispatch(setPrevGlobalData(loaclparma));
}
 
const operations = {
    dispatchCurrentGlobalData,
    dispatchCustomerData,
    dispatchDistributorData,
    dispatchCurrentPrevGlobalData
};

export default operations;
